import React from 'react';

import { Switch } from 'antd';

import { IBVControl } from '../../../models/BVControls/IBVControl';

import './bv-switch.scss';

import BVControl from '../BVControl/bv-control';

interface IBVSwitch extends IBVControl {
    properties: any;
}

const BVSwitch: React.FunctionComponent<IBVSwitch> = ({ className, errorMessage, infoMessage, label, properties, required }) => (
    <BVControl className={`bv-switch ${className}`} errorMessage={errorMessage} infoMessage={infoMessage} label={label} required={required}>
        <Switch {...properties} />
    </BVControl>
);

export default BVSwitch;